import Chart from './Chart';
import List from './List';

export default {
  Chart,
  List,
};
